<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 24px">
            <Col span="6">
                <Input v-model="query.keyword" placeholder="请输入企业名称、统一社会信用代码、法人姓名进行搜索" />
            </Col>
            <Col span="6">
                <Select v-model="query.auth_type" placeholder="认证方式" clearable style="width: 100%">
                    <Option v-for="item in authOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </Col>
            <Col span="4">
                <Button type="primary" icon="ios-search" @click="search">搜索</Button>
            </Col>
        </Row>
        <Table border :loading="loading" :columns="columns" :data="tableData">
            <template slot-scope="{ row }" slot="auth_type">
                <span>{{ authMethodName(row.auth_type) }}</span>
            </template>
            <template slot-scope="{ row }" slot="action">
                <div class="act_cla">
                    <Button 
                        type="primary" 
                        size="small" 
                        v-if="row.business_license_url"
                        @click="handleViewBusinessLicense(row)"
                    >
                        查看营业执照
                    </Button>
                    <Button 
                        type="primary" 
                        size="small" 
                        v-if="row.authbook_path_url"
                        @click="handleViewAuthBook(row)"
                    >
                        查看授权书
                    </Button>
                    <Button 
                        type="success" 
                        size="small" 
                        @click="handleReview(row)"
                    >
                        审核
                    </Button>
                </div>
            </template>
        </Table>
        <br />
        <Page 
            :total="total" 
            :current="query.page" 
            :page-size="query.limit" 
            style="text-align:right" 
            show-elevator
            show-total 
            @on-change="pageChange" 
        />
    </div>
</template>

<script>
import { fetchPendingEnterpriseList, reviewEnterprise, viewBusinessLicense, viewAuthBook } from '@/api/userManage'

export default {
    data() {
        return {
            loading: false,
            query: {
                keyword: '',
                auth_type: '',
                page: 1,
                limit: 20
            },
            total: 0,
            authOptions: [
                { label: '全部', value: '' },
                { label: '运营商三要素', value: 1 },
                { label: '人脸认证', value: 2 }
            ],
            columns: [
                { title: '序号', type: 'index', width: 80, align: 'center' },
                { title: '企业名称', key: 'company_name', align: 'center' },
                { title: '统一社会信用代码', key: 'credit_code', align: 'center', width: 200 },
                { title: '法人名称', key: 'legal_name', align: 'center' },
                { title: '法人身份证号', key: 'legal_id_card', align: 'center', width: 180 },
                { title: '认证方式', slot: 'auth_type', align: 'center' },
                { title: '认证时间', key: 'auth_time', align: 'center' },
                { title: '操作', slot: 'action', align: 'center', width: 300 }
            ],
            tableData: []
        }
    },
    created() {
        this.fetchList()
    },
    methods: {
        authMethodName(value) {
            const current = this.authOptions.find(item => item.value === value)
            return current ? current.label : value || '-'
        },
        pageChange(page) {
            this.query.page = page
            this.fetchList()
        },
        search() {
            this.query.page = 1
            this.fetchList()
        },
        fetchList() {
            this.loading = true
            fetchPendingEnterpriseList(this.query).then(res => {
                const pageData = (res.data && res.data.data) || {}
                const list = pageData.data || []
                this.tableData = this.decorateList(list)
                this.total = pageData.total || list.length
                if (pageData.current_page) {
                    this.query.page = pageData.current_page
                }
            }).catch(err => {
                this.$Message.warning(err && err.msg ? err.msg : '获取待认证企业列表失败')
                // 如果接口失败，使用模拟数据
                this.useMock()
            }).finally(() => {
                this.loading = false
            })
        },
        decorateList(list) {
            return list.map(item => ({
                id: item.id || '',
                company_name: item.company_name || '企业名称',
                credit_code: item.credit_code || '',
                legal_name: item.legal_name || '',
                legal_id_card: item.legal_id_card || '',
                auth_type: item.auth_type || 1,
                auth_time: item.auth_time || item.created_at || '',
                business_license_url: item.business_license_url || '',
                authbook_path_url: item.authbook_path_url || ''
            }))
        },
        useMock() {
            // 模拟数据，用于测试
            this.tableData = [
                { 
                    id: 1, 
                    company_name: '企业名称1', 
                    credit_code: 'vcbcfb12345678912', 
                    legal_name: '法人名称1', 
                    legal_id_card: '236547891236584596', 
                    auth_type: 1, 
                    auth_time: '2022-05-06',
                    business_license_url: 'https://example.com/license1.jpg',
                    authbook_path_url: 'https://example.com/auth1.jpg'
                },
                { 
                    id: 2, 
                    company_name: '企业名称2', 
                    credit_code: 'vcbcfb12345678912', 
                    legal_name: '法人名称2', 
                    legal_id_card: '236547891236584596', 
                    auth_type: 2, 
                    auth_time: '2022-05-08',
                    business_license_url: 'https://example.com/license2.jpg',
                    authbook_path_url: 'https://example.com/auth2.jpg'
                },
                { 
                    id: 3, 
                    company_name: '企业名称3', 
                    credit_code: 'vcbcfb12345678912', 
                    legal_name: '法人名称3', 
                    legal_id_card: '236547891236584596', 
                    auth_type: 2, 
                    auth_time: '2022-05-06',
                    business_license_url: 'https://example.com/license3.jpg',
                    authbook_path_url: 'https://example.com/auth3.jpg'
                }
            ]
            this.total = this.tableData.length
        },
        handleViewBusinessLicense(row) {
            if (row.business_license_url) {
                viewBusinessLicense({ id: row.id }).then(res => {
                    const url = res.data?.url || row.business_license_url
                    window.open(url, '_blank')
                }).catch(() => {
                    // 如果接口失败，直接使用URL打开
                    if (row.business_license_url) {
                        window.open(row.business_license_url, '_blank')
                    } else {
                        this.$Message.warning('营业执照链接不存在')
                    }
                })
            } else {
                this.$Message.warning('营业执照链接不存在')
            }
        },
        handleViewAuthBook(row) {
            if (row.authbook_path_url) {
                viewAuthBook({ id: row.id }).then(res => {
                    const url = res.data?.url || row.authbook_path_url
                    window.open(url, '_blank')
                }).catch(() => {
                    // 如果接口失败，直接使用URL打开
                    if (row.authbook_path_url) {
                        window.open(row.authbook_path_url, '_blank')
                    } else {
                        this.$Message.warning('授权书链接不存在')
                    }
                })
            } else {
                this.$Message.warning('授权书链接不存在')
            }
        },
        handleReview(row) {
            // 显示审核提示模态框
            this.$Modal.confirm({
                title: '提示',
                render: (h) => {
                    return h('div', {
                        class: 'review-warning-content'
                    }, [
                        h('Icon', {
                            props: {
                                type: 'ios-warning',
                                size: 24
                            },
                            class: 'warning-icon'
                        }),
                        h('span', {
                            class: 'warning-text'
                        }, '确保授权书的信息和营业执照完全一致，确保公章清晰、完整、无水印!!!!')
                    ])
                },
                onOk: () => {
                    // 确认审核
                    this.doReview(row)
                },
                okText: '确认',
                cancelText: '取消'
            })
        },
        doReview(row) {
            this.loading = true
            reviewEnterprise({ 
                id: row.id,
                status: 1 // 1表示审核通过，可根据实际需求调整
            }).then(res => {
                this.$Message.success((res && res.msg) || '审核成功')
                this.fetchList()
            }).catch(err => {
                this.$Message.warning(err && err.msg ? err.msg : '审核失败')
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
.act_cla {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}
</style>

<style>
.review-warning-content {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.warning-icon {
    color: #ff9900;
    margin-right: 10px;
    flex-shrink: 0;
}

.warning-text {
    font-size: 14px;
    line-height: 1.5;
    color: #333;
}
</style>

